import { PathWithId } from "@constellation-academy/epic-ui";
import { UserEditPath } from "../user-edit/user-edit.paths";

export class UsersPath extends PathWithId<typeof UsersPath> {
	static readonly pathKey = "users";
	static readonly idKey = "userId";
	static readonly childPaths = [UserEditPath];
}
